import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaChalkboardTeacher, FaStar } from "react-icons/fa";
import { MdEdit, MdOutlineFeaturedPlayList } from "react-icons/md";
import { IoSchool } from "react-icons/io5";
import { MdLiveTv } from "react-icons/md";
import { MdOutlineSettings } from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";
import { FaBars } from "react-icons/fa";
import { IoWalletOutline } from "react-icons/io5";
import { SiGoogleclassroom } from "react-icons/si";
import { PiChalkboardTeacher, PiStudent } from "react-icons/pi";
import { MdReportGmailerrorred } from "react-icons/md";
import { FaBlogger } from "react-icons/fa6";
import { BiSolidOffer } from "react-icons/bi";

import Style from "./style.module.css";

export const routeConfig = [
  {
    path: "/admin",
    icon: MdLiveTv,
    name: "Live Sessions",
  },
  {
    path: "/total-teachers/pending",
    icon: FaChalkboardTeacher,
    name: "Total Teachers",
  },
  {
    path: "/total-students",
    icon: IoSchool,
    name: "Total Students",
  },
  {
    path: "/reports",
    icon: MdReportGmailerrorred,
    name: "Reports",
  },
  {
    path: "/classes/upcoming",
    icon: MdEdit,
    name: "Classes",
  },
  {
    path: "/notifications/teachers",
    icon: IoNotificationsOutline,
    name: "Notifications",
  },
  {
    path: "/profile-setting",
    icon: MdOutlineSettings,
    name: "Profile Setting",
  },
  {
    path: "/wallet",
    icon: IoWalletOutline,
    name: "Platform Wallet",
  },
  {
    path: "/teacher-transactions",
    icon: PiChalkboardTeacher,
    name: "Teacher Transaction's",
  },
  {
    path: "/student-transactions",
    icon: PiStudent,
    name: "Student Transaction's",
  },
  {
    path: "/sessions-history",
    icon: SiGoogleclassroom,
    name: "Session's History",
  },
  {
    path: "/blog-details",
    icon: FaBlogger,
    name: "Blog's",
  },
  {
    path: "/featured-blogs",
    icon: FaStar,
    name: "Featured Blogs",
  },
  {
    path: "/featured-teachers",
    icon: MdOutlineFeaturedPlayList,
    name: "Featured Teachers",
  },
  {
    path: "/subscription-offers",
    icon: BiSolidOffer,
    name: "Subscrition offers",
  },
];

function SideBar({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();

  // Function to check if the path should be active
  const isClassesLinkActive = () => {
    return location.pathname.startsWith("/classes/");
  };

  const isTotalTeachersLinkActive = () => {
    return location.pathname.startsWith("/total-teachers/");
  };

  const isWarningLinkActive = () => {
    return location.pathname.startsWith("/warnings/");
  };

  return (
    <div className="" style={{ position: "sticky", top: 0 }}>
      <div className={Style.sidenav}>
        <div className="d-flex bg-success" style={{ position: "relative" }}>
          <div
            style={{
              backgroundColor: "#effbff",
              padding: 7,
              position: "absolute",
              right: "-15px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: 30,
              height: 30,
              boxShadow: "20px 20px 15px #effbff;",
            }}
          >
            <FaBars
              onClick={toggleSidebar}
              style={{
                color: "#18192c",
                cursor: "pointer",
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>
        {routeConfig.map((route, index) => (
          <NavLink
            key={index}
            to={route.path}
            className={({ isActive }) =>
              (route.name === "Classes" && isClassesLinkActive()) ||
              (route.name === "Total Teachers" &&
                isTotalTeachersLinkActive()) ||
              (route.name === "Warnings" && isWarningLinkActive())
                ? `${Style.nav_link} ${Style.active}`
                : isActive
                ? `${Style.nav_link} ${Style.active}`
                : `${Style.nav_link}`
            }
          >
            <div className="d-flex align-items-center gap-3">
              <span>
                <route.icon size={25} />
              </span>
              <span
                className={isSidebarOpen ? "expand_width" : "collapse_width"}
              >
                {route.name}
              </span>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default SideBar;
